import Vue from 'vue';

export default {
  // 深拷贝
  deepCopy(p, c) {
    c = c || (p.constructor === Array ? [] : {});
    for (var i in p) {
      if (p[i] && p[i].constructor) {
        if (p[i].constructor === Date) {
          c[i] = new Date(p[i]);
        } else if (p[i].constructor === Array) {
          c[i] = [];
          this.deepCopy(p[i], c[i]);
        } else if (p[i].constructor === Function) {
          c[i] = p[i];
        } else if (p[i] instanceof Object) {
          c[i] = {};
          this.deepCopy(p[i], c[i]);
        } else {
          c[i] = p[i];
        }
      } else {
        c[i] = p[i];
      }
    }
    return c;
  },
  copyUrl(text) {
    const div = document.createElement('span');
    div.innerText = text;
    div.setAttribute('style', 'user-select: text;-webkit-user-select: text');
    document.body.appendChild(div);
    const range = document.createRange();
    range.selectNode(div);

    const selection = window.getSelection();
    if (selection.rangeCount > 0) selection.removeAllRanges();
    selection.addRange(range);
    if (document.execCommand) {
      document.execCommand('copy');
      Vue.prototype.$toast('复制成功');
    } else {
      Vue.prototype.$toast('暂不支持此机型，请手动复制');
    }
    document.body.removeChild(div);
  },
  isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  },
  isArray(value) {
    return Object.prototype.toString.call(value) == '[object Array]';
  },
};
